import { render, staticRenderFns } from "./list.vue?vue&type=template&id=c7916caa&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7916caa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7916caa')) {
      api.createRecord('c7916caa', component.options)
    } else {
      api.reload('c7916caa', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=c7916caa&scoped=true", function () {
      api.rerender('c7916caa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/creditInfo/lawsRegulations/list.vue"
export default component.exports